export class Tweet {
    constructor(id, body, author, date, likedBy) {
        this.id = id;
        this.body = body;
        this.author = author;
        this.date = date;
        this.likedBy = likedBy;
    }
}
